import { createSlice } from "@reduxjs/toolkit";
import { IOrderPayload } from "../../types/Warehouses/sales";

export interface State {
  payload: IOrderPayload;
}

const slice = createSlice({
  name: "alesFilters",
  initialState: { payload: {} } as State,
  reducers: {
    salesFilters: (state, { payload }: State) => {
      state.payload = payload;
    }
  }
});

export const { salesFilters } = slice.actions;
export default slice.reducer;
